import script from "./BuyerDashboardWorkingHoursCountryChart.vue?vue&type=script&setup=true&lang=js"
export * from "./BuyerDashboardWorkingHoursCountryChart.vue?vue&type=script&setup=true&lang=js"

import "./BuyerDashboardWorkingHoursCountryChart.vue?vue&type=style&index=0&id=215c59b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-215c59b6"]])

export default __exports__